export const loginInInitialValues = {
    email: '',
    password: '',
    rememberMe: false,
};
export const forgotInInitialValues = {
    email: '',
};
export const resetPasswordInInitialValues = {
    password: '',
    confirmPassword: '',
    uidb64: '',
    token: '',
};

export const changePasswordInInitialValues = {
    newPassword: '',
    confirmNewPassword: '',
};
export const userProfileInInitialValues = {
    firstName: '',
    lastName: '',
    businessName: '',
    email: '',
    profilePicture: '',
};
export const teamMemberInInitialValues = {
    firstName: '',
    lastName: '',
    profilePicture: '',
    password: '',
    confirmPassword: '',
    token: '',
};

export const requestCompanyInitialValues = {
    name: '',
};
